import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import './ModalConfirmingTemplateDeletion.scss'
import { ModalComponent } from "../../../components/Modal/ModalComponent/ModalComponent";

const ModalConfirmingTemplateDeletion = ({
    setIsModal,
    selectedGroupId,
    deleteTemplate,
    deleteTemplateInGroup,
    selectedTemplateId
}) => {

    return (
        <ModalComponent
            onClose={e => setIsModal(false)}
            title='Подтвердите удаление'
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                <div className='modal-confirming-template-deletion__group-btn'>
                    {selectedGroupId !== - 1 && <ButtonBasic
                        red
                        text='Удалить шаблон из группы'
                        width='100%'
                        onClick={(e) => {
                            deleteTemplate(selectedTemplateId, selectedGroupId)
                            setIsModal(false)
                        }}
                    />}

                    <ButtonBasic
                        red
                        text='Удалить шаблон из всех групп'
                        width='100%'
                        onClick={(e) => {
                            deleteTemplateInGroup(selectedTemplateId)
                            setIsModal(false)
                        }}
                    />

                    <ButtonBasic
                        grey
                        text='Отмена'
                        width='100%'
                        onClick={(e) => setIsModal(false)}
                    />
                </div>
            }
        />
    )
}

export { ModalConfirmingTemplateDeletion }